import {Component, ViewChild} from '@angular/core';
import * as Hammer from 'hammerjs';
import {Gesture, NavParams, Platform, Slides, ViewController} from 'ionic-angular';
import {ImageListEntity} from '../../../../list/entities/image-list.entity';
import '../../../../../utils/date/date-prototype.utils';

/**
 * The default implementation of the slider that pops up when you click on an image in the details page
 * @class ImageSliderComponent
 */
@Component({
  selector: 'advtech-image-slider',
  templateUrl: './image-slider.component.html',
})
export class ImageSliderComponent {

  /**
   * The images in the slider.
   * This is 2-way databound in the templates so that if you delete one here it removes it from the details page
   * @private
   * @type ImageListEntity[]
   */
  images: ImageListEntity[];

  /**
   * Options to be passed into the slider
   * @type number
   */
  initialSlide: number;

  /**
   * The current image displayed on the Slides
   * @type {ImageListEntity}
   */
  currentImage: ImageListEntity;

  /**
   * The date formatted
   * @type {string}
   */
  date: string;

  /**
   * For the pinching and swipe down dismiss as hundreds of events fire when doing those actions.
   * @type {boolean}
   */
  dismissing: boolean = false;

  /**
   * Should show the select button
   * @type {boolean}
   */
  selectButton: boolean = false;

  /**
   * Gets the slider element from the template
   * @type Slides
   */
  @ViewChild('mySlider') slider: Slides;

  /**
   * @constructor
   * @param {Platform} platform Platform Instance
   * @param {NavParams} params NavParams Instance
   * @param {ViewController} viewCtrl View Control Instance
   */
  constructor(public platform: Platform,
              public params: NavParams,
              public viewCtrl: ViewController) {

    this.images = params.get('images');
    this.initialSlide = params.get('index');
    this.selectButton = params.get('showSelect') || false;
    this.currentImage = this.images[this.initialSlide];
    this.date = this.getDate();
  }

  /**
   * Called after the view loads
   * @returns {void}
   */
  ionViewDidLoad(): void {
    const nativeElement = this.slider.getNativeElement();
    const pinchGesture = new Gesture(nativeElement);
    const instance = new Gesture(nativeElement, {
      recognizers: [
        [Hammer.Swipe, {direction: Hammer.DIRECTION_VERTICAL}],
      ],
    });

    pinchGesture.listen();
    pinchGesture.on('pinch', (e) => this.dismiss());
    instance.listen();
    instance.on('swipedown', (event) => this.dismiss());
  }

  /**
   * Handles the slide changing
   * @return {void}
   */
  slideChanged(): void {
    this.currentImage = this.images[this.slider.getActiveIndex()];
    this.date = this.getDate();
  }

  /**
   * Dismisses the slider modal
   * @returns {void}
   */
  dismiss(): void {

    if (!this.dismissing) {
      this.viewCtrl.dismiss(null);
    }
    this.dismissing = true;
  }

  /**
   * Handles the edit button on the slide
   * @param  {Event} e
   * @return {void}
   */
  hEditImage(e): void {
    this.viewCtrl.dismiss(this.currentImage);
  }

  /**
   * Handles the select button on the slide
   * @param  {Event} e
   * @return {void}
   */
  hSelectImage(e): void {
    this.viewCtrl.dismiss(this.currentImage);
  }

  /**
   * Gets the formatted date as YYYY-MM-DD
   * @return {string}
   */
  getDate(): string {
    if (!this.currentImage.dateCreated) {
      return 'No Date Set';
    }
    return new Date(this.currentImage.dateCreated.date.iosDateSafeFormat()).format('Y-m-d');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/image/slider/image-slider.component.ts